import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouterLegacy } from 'core/routerUtils';
import { withTranslation } from 'react-i18next';
import {
  AlertMessage,
  AlertNotice,
  SimpleModal,
  Spinner,
  EventDashboardDetails,
} from 'shared/components';
import { MaterialRanges } from 'features/material-chain';
import * as materialChainActions from 'features/material-chain/duck';
import * as tcEventActions from 'features/tc-event-dashboard/duck';
import { mapEventMaterials, mapEventMaterialTypes } from 'features/material-chain/selectors';
import { filter, isEmpty, isUndefined, cloneDeep } from 'lodash';
import { ValidationService } from 'shared/services';
import { materialRangeRules, materialRangeErrorStrings } from 'shared/validations';
import * as MaterialValidation from '../validations';
import { addLeadingZeros } from 'shared/helpers';

class EventRanges extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errors: [],
      discardModalOpen: false,
      isDirty: false,
      showAlertMessage: false,
      alertMessage: '',
      eventMaterials: [],
      removeModalOpen: false,
      uncheckModalOpen: false,
    };

    this.createRangeObject = this.createRangeObject.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleLeadingZero = this.handleLeadingZero.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.handleAdd = this.handleAdd.bind(this);
    this.removeRange = this.removeRange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.isValid = this.isValid.bind(this);
    this.closeUncheckModal = this.closeUncheckModal.bind(this);
    this.confirmUncheckModal = this.confirmUncheckModal.bind(this);
    this.closeRemoveModal = this.closeRemoveModal.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.closeDiscardModal = this.closeDiscardModal.bind(this);
    this.removeAlertMessage = this.removeAlertMessage.bind(this);
  }

  componentDidMount() {
    const eventId = this.props.match.params.eventId;
    const { actions } = this.props;

    actions.getTcEvent(eventId).then(() => {
      const { tcEvent } = this.props;

      if (!isEmpty(tcEvent)) {
        actions.getTestCenterCycle(eventId);
      }
    });
    actions.getTCEventMaterialTypes(eventId);
    actions.getEventAllMaterials(eventId);
  }

  componentDidUpdate(prevProps) {
    if (
      isEmpty(this.props.tcEvent) ||
      !this.props.eventMaterials ||
      !this.props.tcEventMaterialTypes ||
      (!isEmpty(prevProps.tcEvent) &&
        prevProps.eventMaterials === this.props.eventMaterials &&
        prevProps.tcEventMaterialTypes === this.props.tcEventMaterialTypes)
    )
      return;

    const { eventMaterials, tcEventMaterialTypes } = this.props;
    if (eventMaterials.length) {
      this.setState({
        eventMaterials,
      });
    } else {
      const ranges = tcEventMaterialTypes.reduce((acc, materialType) => {
        acc[materialType.id] = [this.createRangeObject(materialType.id)];
        return acc;
      }, []);
      this.setState({
        eventMaterials: ranges,
      });
    }
  }

  createRangeObject(materialTypeId) {
    const { tcEvent } = this.props;

    return {
      testCenterEventId: tcEvent.id,
      materialTypeId: +materialTypeId,
      rangeBegin: '',
      rangeEnd: '',
      count: '',
    };
  }

  handleCheck(e) {
    const materialTypeId = e.target.value;
    let eventMaterials = cloneDeep(this.state.eventMaterials);
    if (e.target.checked) {
      eventMaterials[materialTypeId] = [];
      eventMaterials[materialTypeId].push(this.createRangeObject(materialTypeId));

      this.setState({
        errors: [],
        eventMaterials,
        isDirty: true,
      });
    } else if (
      eventMaterials[materialTypeId]?.some(
        (material) => material.rangeBegin || material.rangeEnd || material.count
      )
    ) {
      this.setState({
        errors: [],
        isDirty: true,
        uncheckModalOpen: true,
        uncheckMaterialTypeId: materialTypeId,
      });
    } else {
      let cloneEventMaterials = cloneDeep(eventMaterials);
      delete cloneEventMaterials[materialTypeId];
      this.setState({
        errors: [],
        isDirty: true,
        uncheckModalOpen: false,
        eventMaterials: cloneEventMaterials,
        uncheckMaterialTypeId: null,
      });
    }
  }

  handleChange(e, materialTypeId) {
    let eventMaterials = cloneDeep(this.state.eventMaterials);
    const [field, index] = e.target.name.split('-');
    const { value } = e.target;

    if (field && !Number.isNaN(index)) {
      eventMaterials[materialTypeId][index][field] = (field === 'count' ? +value : value) || '';

      this.setState({
        errors: [],
        eventMaterials,
        isDirty: true,
      });
    }
  }

  handleLeadingZero(e, materialTypeId) {
    let eventMaterials = cloneDeep(this.state.eventMaterials);
    const [field, index] = e.target.name.split('-');

    if (field && !Number.isNaN(index)) {
      eventMaterials[materialTypeId][index][field] = addLeadingZeros(e.target.value);

      this.setState({
        errors: [],
        eventMaterials,
        isDirty: true,
      });
    }
  }

  handleRemove(materialTypeId, index) {
    const { rangeBegin, rangeEnd, count } = this.state.eventMaterials[materialTypeId][index];

    if (rangeBegin || rangeEnd || count) {
      this.setState({
        removeModalOpen: true,
        removeMaterialTypeId: materialTypeId,
        removeRangeIndex: index,
        isDirty: true,
      });
    } else {
      this.removeRange(materialTypeId, index);
    }
  }

  removeRange(materialTypeId, index) {
    const { removeMaterialTypeId, removeRangeIndex } = this.state;

    if (isUndefined(materialTypeId) && isUndefined(index)) {
      materialTypeId = removeMaterialTypeId;
      index = removeRangeIndex;
    }

    let eventMaterials = cloneDeep(this.state.eventMaterials);
    eventMaterials[materialTypeId].splice(index, 1);

    this.setState({
      errors: [],
      eventMaterials,
      removeModalOpen: false,
      removeMaterialTypeId: null,
      removeRangeIndex: null,
      isDirty: true,
    });
  }

  handleAdd(materialTypeId) {
    let eventMaterials = cloneDeep(this.state.eventMaterials);
    eventMaterials[materialTypeId].push(this.createRangeObject(materialTypeId));

    this.setState({
      errors: [],
      eventMaterials,
      isDirty: true,
    });
  }

  async handleSave() {
    const { actions, tcEvent } = this.props;
    const { eventMaterials } = this.state;
    let data = eventMaterials.flat().filter(Boolean);

    if (this.isValid()) {
      const response = await actions.setEventMaterials(tcEvent.id, {
        testCenterEventMaterials: data,
      });

      if (response.data?.message) {
        this.setState({
          showAlertMessage: true,
          alertMessage: response.data.message,
          alertIsError: true,
        });
      } else {
        sessionStorage.setItem(
          'successSavedMessage',
          'testCenter.testMaterialsRanges.successSavedMessage'
        );
        this.props.history.goBack();
      }
    }
  }

  isValid() {
    const { eventMaterials } = this.state;
    const { allRoomsRanges, tcEvent } = this.props;
    const errors = {};
    const filteredEventMaterials = eventMaterials.filter(Boolean);
    if (filteredEventMaterials.length) {
      let rangeErrors = [];
      eventMaterials.forEach((ranges, materialTypeId) => {
        ranges?.forEach((range, index) => {
          let error = ValidationService.validate(
            range,
            materialRangeRules,
            materialRangeErrorStrings
          );
          if (!isEmpty(error)) {
            rangeErrors.push({
              ...error,
              materialTypeId,
              index,
              fieldsMandatory: true,
            });
          }
        });
      });

      rangeErrors = rangeErrors.concat(
        tcEvent.equatingFlag ? [] : MaterialValidation.checkRangeInterval(eventMaterials),
        tcEvent.equatingFlag ? [] : MaterialValidation.checkRangeOverlap(eventMaterials),
        tcEvent.equatingFlag
          ? []
          : MaterialValidation.checkEventRangeAssignedToRooms(eventMaterials, allRoomsRanges),
        tcEvent.equatingFlag ? [] : MaterialValidation.checkTotalCount(eventMaterials)
      );

      if (!isEmpty(rangeErrors)) {
        errors['materials'] = rangeErrors;
      }
    } else {
      errors['allMaterialsUnchecked'] = true;
    }

    this.setState({
      errors,
    });

    return !Object.keys(errors).length;
  }

  closeUncheckModal() {
    this.setState({
      uncheckModalOpen: false,
      uncheckMaterialTypeId: null,
    });
  }

  closeRemoveModal() {
    this.setState({
      removeModalOpen: false,
    });
  }

  confirmUncheckModal() {
    const { uncheckMaterialTypeId } = this.state;
    let eventMaterials = cloneDeep(this.state.eventMaterials);

    delete eventMaterials[uncheckMaterialTypeId];
    this.setState({
      eventMaterials,
      uncheckModalOpen: false,
      uncheckMaterialTypeId: null,
    });
  }

  handleBack() {
    if (this.state.isDirty) {
      this.setState({
        discardModalOpen: true,
      });
    } else {
      this.props.history.goBack();
    }
  }

  closeDiscardModal(goBack) {
    if (goBack) {
      this.props.history.goBack();
    }
    this.setState({
      discardModalOpen: false,
    });
  }

  removeAlertMessage() {
    this.setState({
      showAlertMessage: false,
      alertMessage: '',
    });
  }

  render() {
    const { loading, testCenterCycle, tcEvent, tcEventMaterialTypes } = this.props;

    const {
      alertMessage,
      alertIsError,
      errors,
      showAlertMessage,
      eventMaterials,
      discardModalOpen,
      removeModalOpen,
      uncheckModalOpen,
    } = this.state;

    if (
      isEmpty(tcEvent) ||
      tcEvent.loading ||
      isEmpty(testCenterCycle) ||
      testCenterCycle.loading ||
      loading
    ) {
      return <Spinner />;
    }

    return (
      <div className="event-ranges">
        <div className="mb-30 title-container">
          <h4 className="pt-3">{this.props.t('testCenter.testMaterialsRanges.title')}</h4>
        </div>
        <EventDashboardDetails
          date={tcEvent.testingEvent.name}
          name={testCenterCycle.testCenterProgram.testCenter?.name}
        />

        {errors['allMaterialsUnchecked'] && (
          <AlertNotice
            message={this.props.t('testCenter.testMaterialsRanges.allMaterialsUnchecked')}
            type="error"
          />
        )}

        <div className="event-ranges-container">
          {tcEventMaterialTypes?.map((materialType) => (
            <MaterialRanges
              materialType={materialType}
              materialsRanges={eventMaterials[materialType.id]}
              key={`material-${materialType.id}`}
              handleRemove={this.handleRemove}
              handleAdd={this.handleAdd}
              handleChange={this.handleChange}
              handleLeadingZero={this.handleLeadingZero}
              handleCheck={this.handleCheck}
              errors={
                errors.materials && filter(errors.materials, { materialTypeId: materialType.id })
              }
              eventRange
            />
          ))}
        </div>

        <div className="buttons-container w-100">
          <button className="btn btn-warn w-50" onClick={this.handleBack}>
            {this.props.t('common.labels.back')}
          </button>
          <button className="btn btn-action w-50" onClick={this.handleSave}>
            {' '}
            {this.props.t('common.labels.save')}
          </button>
        </div>

        <SimpleModal
          isOpen={uncheckModalOpen}
          onCancel={this.closeUncheckModal}
          onConfirm={this.confirmUncheckModal}
          confirmLabel={this.props.t('testCenter.testMaterialsRanges.uncheckModalConfirmBtn')}
          cancelLabel={this.props.t('common.labels.back')}
          headline={this.props.t('testCenter.testMaterialsRanges.uncheckModalTitle')}
          message={this.props.t('testCenter.testMaterialsRanges.uncheckModalMessage')}
        />

        <SimpleModal
          isOpen={removeModalOpen}
          onCancel={this.closeRemoveModal}
          onConfirm={() => this.removeRange()}
          confirmLabel={this.props.t('testCenter.testMaterialsRanges.removeModalConfirmBtn')}
          cancelLabel={this.props.t('common.labels.back')}
          headline={this.props.t('testCenter.testMaterialsRanges.removeModalTitle')}
          message={this.props.t('testCenter.testMaterialsRanges.removeModalMessage')}
        />

        <SimpleModal
          isOpen={discardModalOpen}
          onCancel={() => this.closeDiscardModal(false)}
          onConfirm={() => this.closeDiscardModal(true)}
          confirmLabel={this.props.t('common.labels.yes')}
          cancelLabel={this.props.t('common.labels.no')}
          headline={this.props.t('common.backModal.title')}
          message={this.props.t('common.backModal.discardPageMessage')}
          buttonsReverseOrder
        />

        <AlertMessage
          show={showAlertMessage}
          removeMessage={this.removeAlertMessage}
          message={alertMessage}
          isError={alertIsError}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    tcEvent: state.tcEvent.currentEvent || {},
    testCenterCycle: state.tcEvent.testCenterCycle || {},
    loading: state.materialChain.loading,
    tcEventMaterialTypes: mapEventMaterialTypes(state),
    eventMaterials: mapEventMaterials(state),
    allRoomsRanges: state.materialChain.eventAllMaterials.roomMaterials || [],
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...materialChainActions,
        ...tcEventActions,
      },
      dispatch
    ),
  };
}

export default withTranslation()(
  withRouterLegacy(connect(mapStateToProps, mapDispatchToProps)(EventRanges))
);

EventRanges.propTypes = {
  actions: PropTypes.shape({
    getTCEventMaterialTypes: PropTypes.func.isRequired,
    getEventAllMaterials: PropTypes.func.isRequired,
    getTcEvent: PropTypes.func.isRequired,
    getTestCenterCycle: PropTypes.func.isRequired,
    setEventMaterials: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      eventId: PropTypes.string,
    }).isRequired,
  }).isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
  }).isRequired,
  tcEvent: PropTypes.shape({
    id: PropTypes.number,
    loading: PropTypes.bool,
    equatingFlag: PropTypes.bool,
    testingEvent: PropTypes.shape({
      name: PropTypes.string,
    }),
  }),
  testCenterCycle: PropTypes.shape({
    loading: PropTypes.bool,
    testCenterProgram: PropTypes.shape({
      testCenter: PropTypes.shape({
        name: PropTypes.string,
      }),
    }),
  }),
  loading: PropTypes.bool,
  tcEventMaterialTypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
    })
  ),
  eventMaterials: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({}))),
  allRoomsRanges: PropTypes.arrayOf(PropTypes.shape({})),
  t: PropTypes.func.isRequired,
};
